'use client';

import PageError from '@/components/error/page-error';
import SendToSentry from '@/components/send-to-sentry';

export default function GlobalError({
  error,
  // reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const errorCode =
    error.message === 'NETWORK ERROR' || error.cause === 'NETWORK ERROR'
      ? 503
      : 500;
  const errorDetails =
    errorCode === 503
      ? 'Kindly ensure that your internet connection is stable.'
      : 'Our team has been notified.';
  return (
    <html lang="en">
      <body>
        <PageError
          showContactSupport={errorCode === 500}
          statusCode={errorCode}
          statusMessage="There was a problem with the page."
          details={errorDetails}
        />
      </body>
      <SendToSentry error={error} />
    </html>
  );
}
